import classNames from 'classnames';
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Sidebar from './Sidebar';
import { SIDEBAR_STATUSES } from './constants';

export default function Layout({
  activeTab,
  groupId,
  children,
  sidebarDefaultState,
}) {
  const [sidebarState, setSidebarState] = useState(sidebarDefaultState);

  function handleToggleSidebarState(sidebarState) {
    setSidebarState(sidebarState);
  }

  function isSidebarExpanded() {
    return sidebarState === SIDEBAR_STATUSES.EXPANDED;
  }

  return (
    (<div data-testid="div-302c7cce">
      <Sidebar
        activeTab={activeTab}
        groupId={groupId}
        onToggle={handleToggleSidebarState}
        defaultState={sidebarDefaultState}
      />
      <main
        data-testid="main-a80b7cbc"
        className={classNames('py-5 sm:py-6 flex-1 pl-16', {
          'lg:pl-72': isSidebarExpanded(),
        })}>
        {children}
      </main>
    </div>)
  );
}

Layout.propTypes = {
  groupId: PropTypes.string,
  sidebarDefaultState: PropTypes.oneOf([
    SIDEBAR_STATUSES.EXPANDED,
    SIDEBAR_STATUSES.COLLAPSED,
  ]),
  activeTab: PropTypes.string,
};

Layout.propTypes = {
  sidebarDefaultState: SIDEBAR_STATUSES.EXPANDED,
  activeTab: '',
};
